/* Copyright (c) 2024 Xperi. All Rights Reserved. */

export enum ErrorPriority {
    NO_NETWORK_ERROR = 999,
    LOCATION_RESTRICTION = 996,
    GENERAL_RESTRICTIONS = 995,
    SESSION_AND_PLAYER_ERROR = 994,
    STILL_THERE = 900,
}
